import {
  AddOutlined,
  AttachmentOutlined,
  EditOutlined,
  RefreshOutlined,
} from "@material-ui/icons";
import {
  Box,
  CardHeader,
  Chip,
  Grid,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import useToast from "../../../../hooks/useToast";
import useConfirmation from "../../../../hooks/useConfirmation";
import { useQuery } from "../../../../hooks/useQuery";
import AppButton from "../../shares/AppButton";
import PropositionTechniqueEtFinanciereForm from "./PropositionTechniqueEtFinanciereForm";
import { PropositionTechniqueFinanciereService } from "../../../../service/PropositionTechniqueFinanciereService";
import AppChatBubble from "../../shares/reusable/AppChatBubble";
import useCrudApi from "../../../../hooks/useCrudApi";
import { AMIService } from "../../../../service/AMI/AMIService";
import AppTypography from "../../shares/reusable/AppTypography";

const PropositionTechniqueFinanciereClient = ({ currentAssociation }) => {
  const [membres, setMembres] = useState([]);
  const { Toast, showToast } = useToast();
  const [dataLoading, setDataLoading] = useState(false);
  const [openPropositionForm, setOpenPropositionForm] = useState(false);
  const { DialogComponent, openConfirmDialog } = useConfirmation();
  const [selectedUuidProposition, setSelectedUuidProposition] = useState(null);
  const query = useQuery();
  const amiApi = useCrudApi(AMIService);
  const handleFetchData = (currentAssociation) => {
    // if (!currentAssociation.uuid) return;
    setDataLoading(true);
    PropositionTechniqueFinanciereService.liste({
      id_type: query.get("job_id"),
    })
      .then((res) => {
        if (res && res.data) {
          setMembres(res.data);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleShowPJ = (row) => {
    window.open(row.lien_pj, "_blank");
  };

  const table_colonne = [
    {
      field: "created_at",
      headerName: "Date de soumission",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "type_proposition",
      headerName: "Type de proposition",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "detail",
      headerName: "Detail de la proposition",
      flex: 1,
      minWidth: 400,
    },
    {
      field: "pj",
      headerName: "Piece jointe ",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        <Grid>
          <a href={params.row.lien_pj}>{params.row.pj}</a>
        </Grid>;
      },
    },
    {
      field: "statut",
      headerName: "Statut de la proposition",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return (
          <span
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {params.row.statut && (
              <Chip
                size="small"
                label={params.row.statut}
                color={
                  params.row.statut === "à corriger"
                    ? "warning"
                    : params.row.statut === "Validée"
                      ? "success"
                      : "error"
                }
                variant="outlined"
              />
            )}
          </span>
        );
      },
    },
    {
      field: "commentaire_fid",
      headerName: "Commentaire de l'equipe du FID ",
      flex: 1,
      minWidth: 400,
    },
    {
      field: "",
      headerName: "Actions ",
      minWidth: 120,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              color="primary"
              disabled={params.row.statut}
              title="Modifier la proposition"
              onClick={(e) => handleOpenPropositionForm(params.row.uuid)}
            >
              <EditOutlined />
            </IconButton>
            <IconButton
              disabled={!params.row.lien_pj}
              color="secondary"
              title="Afficher piece jointe"
              onClick={(e) => handleShowPJ(params.row)}
            >
              <AttachmentOutlined />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchData();
  }, [currentAssociation]);

  useEffect(() => {
    if (query.get("job_id")) {
      amiApi.findOne(query.get("job_id"));
    }
  }, [query.get("job_id")]);

  const handleAddNewProposition = () => {
    handleOpenPropositionForm(null);
  };

  const handleOpenPropositionForm = (uuid) => {
    setOpenPropositionForm(true);
    setSelectedUuidProposition(uuid);
  };

  const handleCloseSelectMembre = () => {
    setOpenPropositionForm(false);
    handleFetchData(currentAssociation);
  };

  return (
    <>
      <PropositionTechniqueEtFinanciereForm
        idProposition={selectedUuidProposition}
        open={openPropositionForm}
        onFormClose={handleCloseSelectMembre}
      />
      <DialogComponent />
      <Toast />
      <CardHeader
        title={
          <AppTypography
            titre={amiApi.data.findOneById?.data.libelle_type}
            text={
              `Proposition technique & financiere - ${amiApi.data.findOneById?.data.libelle_type.substring(0, 40)} ` +
              (amiApi.data.findOneById?.data.libelle_type.length > 40
                ? '...'
                : '')
            }
            loading={amiApi.loading.findOneById}
            variant="h5"
          />
        }
        titleTypographyProps={{ variant: "h5" }}
        avatar={
          <Grid>
            <IconButton onClick={(e) => handleFetchData(currentAssociation)}>
              <RefreshOutlined />
            </IconButton>
          </Grid>
        }
        action={
          <Grid>
            <AppButton
              disabled={membres.some(
                (membre) => membre.statut && membre.statut !== "à corriger",
              ) || 1===1}
              title={
                membres.some(
                  (membre) => membre.statut && membre.statut !== "à corriger",
                )
                  ? "Votre demande a deja ete refusée et vous ne pouvez plus ajouter de nouvelles propositions"
                  : "Ajouter une nouvelle proposition"
              }
              text="Ajouter"
              onClick={handleAddNewProposition}
              variant="outlined"
              icon={<AddOutlined />}
            />
          </Grid>
        }
      />
      <Grid sx={{ overflowX: "auto", width: "100" }}>
        <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
          <LinearProgress />
        </Box>
        <DataGrid
          sx={{
            width: {
              xs: "85.5vw",
              sm: "90vw",
              md: "93.5vw",
              lg: "100%",
              height: "60vh",
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)",
              alignContent: "center",
            },
            "& .MuiDataGrid-columnHeaders": {
              borderRight: "1px solid rgba(224, 224, 224, 1)",
            },
          }}
          getRowHeight={() => "auto"}
          getRowId={(row) => row.id_proposition}
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          columns={table_colonne}
          rows={membres}
        />
        {/*  {membres.map((item, idx) => (
          <Grid>
            <AppChatBubble
              dateTime={item.created_at}
              message={item.detail}
              expediteur={"Responsable Agence"}
              isOwn={false}
            />
            {item.commentaire_fid && (
              <AppChatBubble
                dateTime={item.updated_at}
                message={item.commentaire_fid}
                expediteur={"Equipe fid"}
                isOwn={true}
              />
            )}
          </Grid>
        ))} */}
      </Grid>
    </>
  );
};

export default PropositionTechniqueFinanciereClient;
